export function isAdminUser(userType) {
  const adminRoles = new Set([
    "admin",
    "administrator",
    "superadmin",
    "super_admin",
    "role_admin",
    "role_administrator",
    "role_superadmin",
    "role_super_admin",
  ]);

  return (Array.isArray(userType) ? userType : [userType]).some((role) => {
    const normalized = String(role || "").trim().toLowerCase();
    if (/(?:^|[^a-z])(?:non|not|no)[\s_-]*admin(?:$|[^a-z])/.test(normalized)) {
      return false;
    }

    return normalized.split(/[\s,;|]+/).some((roleName) => adminRoles.has(roleName));
  });
}

export function getUserSiteIds(authUser) {
  if (!authUser) return [];

  const ids = new Set();
  const add = (value) => {
    if (value !== undefined && value !== null && value !== "") {
      ids.add(String(value));
    }
  };

  add(authUser.siteId);
  add(authUser.site_id);
  add(authUser.siteid);

  if (authUser.site && typeof authUser.site === "object") {
    add(authUser.site.id);
    add(authUser.site.siteId);
    add(authUser.site.site_id);
  }

  if (Array.isArray(authUser.siteIds)) {
    authUser.siteIds.forEach(add);
  }

  if (Array.isArray(authUser.site_ids)) {
    authUser.site_ids.forEach(add);
  }

  if (Array.isArray(authUser.sites)) {
    authUser.sites.forEach((site) => {
      if (site && typeof site === "object") {
        add(site.id);
        add(site.siteId);
        add(site.site_id);
      }
    });
  }

  return Array.from(ids);
}

export function filterSitesForUser(siteArray, userType, authUser) {
  if (!Array.isArray(siteArray)) return [];

  if (isAdminUser(userType)) {
    return siteArray;
  }

  const authorizedSiteIds = getUserSiteIds(authUser);
  if (authorizedSiteIds.length === 0) {
    return [];
  }

  return siteArray.filter((site) => {
    const siteId = String(site?.id ?? site?.siteId ?? site?.site_id ?? site?.site?.id ?? "");
    return authorizedSiteIds.includes(siteId);
  });
}
